import React, { useState, useEffect, useLayoutEffect, useCallback, forwardRef, useImperativeHandle, useRef } from "react";
import { useParams } from "react-router-dom";

import ReactEcharts from "echarts-for-react";
import moment from "moment";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

import $ from "jquery";

import axios from "@app/lib/axios";
import * as Constant from "@app/Constant.js";
import * as util from "@app/lib/utility";
import playStyle from "../components/style";

import "./style.css";

const marginBase = 3;
const maxPlayLog = 44;
const tableTRLineHeightBase = 20;

const ReportTitle = ({}) => {
    return (
        <div id="report-header-title" className="row">
            <div className="col text-center title">
                <div>플레이딩동 월 별 사용 현황</div>
            </div>
        </div>
    );
};
const ReportInfo = ({ nurseryUniqName, contractCount, selectedMonth, margin }) => {
    return (
        <div id="report-header-info" className={`row mt-${margin}`}>
            <div className="col h6 d-flex justify-content-end">
                <table>
                    <tbody>
                        <tr className="">
                            <td>원 명 :</td>
                            <td className="report-info nursery-name text-primary text-nowrap">{nurseryUniqName} ({contractCount}개 반)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
const ReportTableDetail = ({classInfo, plays, isLastPage}) => {
    return (
        <table className="report-table-play">
            <thead>
                <th>수업 일시</th>
                <th>수업 시간(분)</th>
                <th>참여 원아 수(명)</th>
                <th>콘텐츠 이용</th>
                <th>활동 저장</th>
            </thead>
            <tbody>
                {plays && plays.map((p) => {
                    return (
                    <tr style={{ lineHeight: `15px` }}>
                        <td>{p.startDate ? p.startDate : '-'}</td>
                        <td>{p.playTime ? p.playTime : '-'}</td>
                        <td>{p.playChildCount ? p.playChildCount : '-'}</td>
                        <td>{p.playContentCount ? p.playContentCount : '-'}</td>
                        <td>{p.playResultCount ? p.playResultCount : '-'}</td>
                    </tr>);
                })}
            </tbody>
            {isLastPage && (
                <tfoot>
                    <th>합계</th>
                    <td>{classInfo.totalPlayTime.toLocaleString()}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tfoot>
            )}
        </table>
    );
};
const ReportTable = ({ classInfo, plays, page, totalPage, tableTRLineHeight }) => {
    return (
        <div className="col report-sub">
            <div className={`row`}>
                <div className="col report-sub-table">
                    <table>
                        {page == 1 && (
                            <thead>
                                <tr style={{ lineHeight: `${tableTRLineHeight}px` }}>
                                    <th className="header" style={{ width: "15%" }}>
                                        계정
                                    </th>
                                    <td style={{ width: "35%" }}>
                                        {classInfo.userId}
                                    </td>
                                    <th className="header" style={{ width: "15%" }}>
                                        반 명
                                    </th>
                                    <td style={{ width: "35%" }}>
                                        {classInfo.className}
                                    </td>
                                </tr>
                                <tr style={{ lineHeight: `${tableTRLineHeight}px` }}>
                                    <th className="header" style={{ width: "15%" }}>
                                        계약 원아 수
                                    </th>
                                    <td style={{ width: "35%" }}>
                                        {classInfo.childContract}
                                    </td>
                                    <th className="header" style={{ width: "15%" }}>
                                        등록 원아 수
                                    </th>
                                    <td style={{ width: "35%" }}>
                                        {classInfo.childRegist ? classInfo.childRegist : '-'}
                                    </td>
                                </tr>
                            </thead>
                        )}
                        <tbody>
                            <tr style={{ lineHeight: `${tableTRLineHeight}px` }}>
                                <th className="header" style={{ width: "15%" }}>
                                    이용 현황
                                </th>
                                <td style={{ width: "85%", padding: "5px" }} colSpan={3}>
                                    <ReportTableDetail plays={plays} classInfo={classInfo} isLastPage={page == totalPage} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {totalPage > 1 && (
                        <div className="text-center mt-2" style={{width: "100%"}}>{page} / {totalPage}</div>
                    )}
                </div>
            </div>
        </div>
    );
};

const ReportPage = forwardRef(({ selectedMonth, nurseryUniqName, stat }, ref) => {
    const [statPaging, setStatPaging] = useState(false);
    
    useEffect(() => {
        if (stat) {
            let statPaging = [];
            if(stat && stat.length > 0) {
                stat.forEach((s) => {
                    const classStat = {
                        userId: s.userId, className: s.className, childContract: s.childContract, childRegist: s.childRegist
                        , totalPlayTime: 0, plays: []
                    };
                    s.plays.forEach((p) => {
                        p.playTime = moment(p.endDate).diff(moment(p.startDate), 'minute');
                        classStat.totalPlayTime += p.playTime;
                    })
                    if(s.plays.length > maxPlayLog) {
                        while (s.plays.length > 0) {
                            classStat.plays.push(s.plays.splice(0, maxPlayLog));
                        }
                    } else {
                        classStat.plays = [s.plays];
                    }
                    statPaging.push(classStat);
                });
            }
            setStatPaging(statPaging);
        }
        return () => {};
    }, [stat]);

    useEffect(() => {
        return () => {};
    }, [statPaging]);
    const pxTomm = (px) => {
        return Math.floor(px * 0.264583);
    };
    
    return (
        <div id="pageToPrint" className="page-root stat-report" ref={ref}>
                {statPaging && statPaging.length > 0 && statPaging.map((s) => {
                    {return s.plays.map((sc, index) => {
                        return index == 0 ? (
                            <div className="page">
                                <div className="sub-page">
                                    <ReportTitle />
                                    <ReportInfo nurseryUniqName={nurseryUniqName} contractCount={statPaging.length} selectedMonth={selectedMonth} margin={3} />
                                    <ReportTable
                                        classInfo={s}
                                        plays={sc}
                                        page={index + 1}
                                        totalPage={s.plays.length}
                                        tableTRLineHeight={tableTRLineHeightBase}
                                    />
                                </div>
                            </div>
                        ) : (
                        <div className="page">
                            <div className="sub-page">
                                <ReportTable
                                    classInfo={s}
                                    plays={sc}
                                    page={index + 1}
                                    totalPage={s.plays.length}
                                    tableTRLineHeight={tableTRLineHeightBase}
                                />
                            </div>
                        </div>
                        )}
                    )}
                })}
        </div>
    );
});

export default ReportPage;
